import styled from 'styled-components';

export const ButtonContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .skip-text {
    font-size: 0.85em;
    opacity: 0.9;
  }
`;

